export const pkg = {
  name: 'isomorphic-git',
  version: '1.41.8',
  agent: 'git/isomorphic-git@1.41.8',
}
